import {withTheme} from '@rneui/themed';

import Text, {TextProps} from '../ui-controls/Text';

export default withTheme<TextProps>(Text, 'LMGText');

declare module '@rneui/themed' {
  export interface ComponentTheme {
    LMGText: Partial<TextProps | {color?: string}>;
  }
}
